import { Expose, Type } from "class-transformer";
import type { IAiChatbotCmsPromptDto } from "./ai-chatbot-cms-prompt.dto.interface";

export class AiPromptInputDataDto {
  @Expose()
  id!: number;

  @Expose()
  promptMessage!: string | null;

  @Expose()
  displayText!: string | null;
}

export class AiPromptPathDataDto {
  @Expose()
  id!: number;

  @Expose()
  path!: string | null;
}

export class AiChatbotCmsPromptDto implements IAiChatbotCmsPromptDto {
  @Expose()
  id!: number;

  @Expose()
  active!: boolean;

  @Expose()
  priority!: number;

  @Expose()
  showIn!: string;

  @Expose()
  @Type(() => AiPromptInputDataDto)
  promptInput!: AiPromptInputDataDto;

  @Expose()
  @Type(() => AiPromptPathDataDto)
  promptPath!: AiPromptPathDataDto;

  @Expose()
  defaultErrorResponse?: string;
}
